// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  staff: (t, data?, options?) => t('enum.password-type.staff.name', data, options),
  user: (t, data?, options?) => t('enum.password-type.user.name', data, options),
  /* eslint-enable max-len */
};
